import button from './components/button';
import headerImage from './components/headerImage';
import style from './components/style';
import footer from './components/footer';
import tinycolor from 'tinycolor2';

module.exports = {
  text: 'New message from the hiring platform',
  value: 'contact',
  subject: 'New Message',
  mjml(params) {
    const { brandingSettings: branding } = params;
    const slots = params.slots.map(({ content }) => ({
      content: content
        .replace(/{{[\s]*company\.name[\s]*}}/g, '{{defaults company.branding.name company.name "Referrals"}}'),
    }));

    return `<mjml>
      <mj-head>
        <mj-title>${params.subject}</mj-title>
        <mj-include path="../include/styles.mjml"/>
        <mj-attributes>
          <mj-class name="content" background-color="${branding.backgroundColour || '#ffffff'}"/>
        </mj-attributes>
        <mj-style>
          ${style(branding)}
        </mj-style>
      </mj-head>

      <mj-body
        width="760px"
        background-color="${branding.backgroundColour || '#ffffff'}"
      >

        ${!branding.hideBrandLogo ? `<mj-section>
          <mj-column>
            <mj-include path="../include/branding-logo.mjml"/>
          </mj-column>
        </mj-section> ` : ''}

        ${branding.headerImage ? headerImage(branding.headerImage) : ''}

        <mj-section mj-class="content">
          <mj-column>
            <mj-text color="${branding.secondaryColour || '#333333'}">
              <div class="text-content">${slots[0].content}</div>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section
          padding="44px 16px"
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
        >
          <mj-column>${button('Login Now', branding)}</mj-column>
        </mj-section>

        ${footer(branding)}

        <mj-include path="../include/footer-disclaimer.mjml"/>
      </mj-body>
    </mjml>`;
  },
  slots: [
    {
      name: 'Main Content',
      type: 'html',
      defaultContent: '',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/emails/genericContact.js